import { motion } from 'motion/react';
import { PANEL_MUTED } from './lexCounselPanelUi';

type Props = {
  status?: string;
  note?: string;
};

export default function LexCounselThinkingIndicator({ status = 'Thinking', note }: Props) {
  return (
    <div className={`flex flex-col gap-1 ${PANEL_MUTED}`}>
      <div className="flex items-center gap-1.5">
        <motion.span
          className="bg-gradient-to-r from-[var(--counsel-shimmer-from)] via-[var(--counsel-shimmer-via)] to-[var(--counsel-shimmer-from)] bg-clip-text text-transparent"
          style={{ backgroundSize: '200% 100%', WebkitBackgroundClip: 'text' }}
          animate={{ backgroundPosition: ['0% 50%', '100% 50%', '0% 50%'] }}
          transition={{ duration: 2.2, repeat: Infinity, ease: 'easeInOut' }}
        >
          {status}
        </motion.span>
        <span className="flex gap-0.5" aria-hidden>
          {[0, 1, 2].map((i) => (
            <motion.span
              key={i}
              className="inline-block h-1 w-1 rounded-full bg-[var(--counsel-text-muted)]"
              animate={{ opacity: [0.25, 1, 0.25], y: [0, -2, 0] }}
              transition={{ duration: 0.9, repeat: Infinity, delay: i * 0.15, ease: 'easeInOut' }}
            />
          ))}
        </span>
      </div>
      {note ? <p className="text-[12px] leading-snug text-[var(--counsel-text-muted)]">{note}</p> : null}
    </div>
  );
}
